import { useEffect, useState } from "react";

export function useResume(token) {
  const [resume, setResume] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!token) return;

    async function fetchResume() {
      try {
        const res = await fetch(`${import.meta.env.VITE_API_URL}/api/resume`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();
        if (res.ok) {
          setResume(data.resume);
        } else {
          console.error("Erro ao buscar currículo:", data.error);
        }
      } catch (err) {
        console.error("Erro ao buscar currículo:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchResume();
  }, [token]);

  const saveResume = async (data) => {
    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/api/resume`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      const result = await res.json();
      if (res.ok) {
        setResume(result.resume);
        setIsEditing(false);
        return { success: true };
      } else {
        return { success: false, error: result.error };
      }
    } catch (err) {
      console.error("Erro ao salvar currículo:", err);
      return { success: false, error: err };
    }
  };

  return {
    resume,
    setResume,
    saveResume,
    isEditing,
    setIsEditing,
    loading,
  };
}
